import React, { Component } from 'react'
import PropTypes from 'prop-types'
import getClassNameFactory from '@wel-ui/utility-class-names'
import './Pill.css'
import * as actionCreators from '../actions'
import { connect } from 'react-redux'

const getClassName = getClassNameFactory('Pill')

class Pill extends Component {
  render() {
    return (
      <button
        id={this.props.answerLetter}
        className={getClassName()}
        onClick={() => {
          this.props.selectAnswer(
            this.props.id,
            this.props.children,
            this.props.answerLetter,
          )
          this.props.onClick(this.props.nextStep)
        }}>
        {this.props.children}
      </button>
    )
  }
}

Pill.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
}

function mapDispatchToProps(dispatch) {
  return {
    selectAnswer: (question, answer, answerLetter) => {
      dispatch(
        actionCreators.ActionCreators.selectAnswer(
          question,
          answer,
          answerLetter,
        ),
      )
    },
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(Pill)



// WEBPACK FOOTER //
// ./js/components/Pill/Pill.js